/**
 * IconPickerField — thin passthrough to uxp `IconPicker`.
 *
 * uxp `IconPicker` accepts BOTH the new `'prefix:name'` format and legacy camelCase
 * keys, and on mount auto-converts a legacy value to the new format (firing
 * `onChange` with it). That is the intended FORWARD MIGRATION: existing widgets keep
 * rendering (legacy keys resolve via `window.IconMetadata` at render), and editing an
 * icon persists it in the new format. There is no local icon table anymore.
 */
import * as React from 'react';
import { IconPicker } from 'uxp/components';

/** Legacy `Icons`-key → uxp `'prefix:name'`, or null when not a known legacy key.
 *  Sourced from the CDN `window.IconMetadata` (no bundled icon table). Kept for the
 *  few call sites that need the raw conversion (e.g. EditorHeader avatar). */
export function iconKeyToUxp(key: string | undefined | null): string | null {
    if (!key) return null;
    const M = (typeof window !== 'undefined' ? (window as any).IconMetadata : undefined);
    if (M && M.isLegacyKey(key)) return M.convertLegacyKey(key) || null;
    return null;
}

export interface IIconPickerFieldProps {
    value?: string;
    onChange: (value: string) => void;
    label?: string;
    className?: string;
    compactMode?: boolean;
    hideLabel?: boolean;
    placeholder?: string;
    onClear?: () => void;
}

const IconPickerField: React.FC<IIconPickerFieldProps> = ({ value, onChange, ...rest }) => {
    return <IconPicker value={value} onChange={onChange} {...rest} />;
};

export default IconPickerField;
